import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getResourceList, saveCity, promodata, eventResource, updateResource } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import swal from 'sweetalert';

class resourcesList extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              resource_id: 0,
              resource_title: '',
              resource_banner: '',
              resource_category: '',
              resource_attchment: '',
              old_resource_banner: '',
              old_resource_attchment: '',
              resourceslist: [],
              openedAdd:false
        };

        this.getResourceList();

    }

    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_resource', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });


    }

    openAddBox= () => {

      this.setState({openedAdd:true});
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
      
    };  

    deleteResource(delete_id = '') {
      swal({
        title: "Are you sure to Delete Resource?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            let ins = JSON.stringify({
              resource_id: delete_id ? delete_id : this.state.delete_id,
              role: 1,
              url: 'delete_resource'
            });
            eventResource(ins).then((res) => {
              let toastr = '';
              if (res.status === 1) {
                toastr = window.toastr.success;
                toastr('', res.message, {
                  positionClass: "toast-bottom-right",
                  containerId: "toast-bottom-right"
                });
                setTimeout(function () {
                  window.location.reload();
                }, 1000);
              } else {
                toastr = window.toastr.error; //warning
                toastr('', res.message, {
                  positionClass: "toast-bottom-right",
                  containerId: "toast-bottom-right"
                });
              }
            });
          }
        });
      return false;

    }


    saveResource = ()=>{
        
       let insert = {
        resource_id: this.state.resource_id,
        resource_category: this.state.resource_category,
        resource_title: this.state.resource_title,
        resource_banner: this.state.resource_banner,
        resource_attchment: this.state.resource_attchment
      }
      updateResource(insert).then((response) => {
        if (response.status == 1) {
          this.setState({openedAdd:false});
          this.getResourceList();
        } else {
          alert("Saving error");
        }
      });
     
    }

    getResourceList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getResourceList(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            resourceslist: res.list
            
          });
        } else {
          this.setState({
            resourceslist: [],
          });
        }
      });
    }    

    render() {

        const { resourceslist } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Resources</h4>
                 
 
                  <div class="float-right"><button class="btn btn-primary btn-sm" onClick={this.openAddBox}>Add New</button></div>
                 
                  {this.state.openedAdd &&
                    <form>
                     <div class="row col-lg-12">
                      
                      <div class="form-group">
                        
                        <div class="form-row">
                          
                          <label>Category</label>
                          <select className='form-control selectpicker'
                            onChange={this.handleChange}
                            title='Select Category'
                            name='resource_category'
                            value={this.state.resource_category}>
                            <option value='1'>2 – 5 years</option>
                            <option value='2'>6 – 9 years old</option>
                            <option value='3'>9 – 11  years</option>
                            <option value='4'>12 – 15 years</option>
                          </select>

                        </div>
                      
                      <div class="form-row">
                        
                          <label> Title <span className="astrick">*</span></label>
                         
                        
                          <input name='resource_title' className='form-control' type='text' value={this.state.resource_title}
                            onChange={this.handleChange} />
                          
                      </div>

                      <div class="form-row">
                        
                          <label> Resource to Download <span className="astrick">*</span></label>
                         
                        
                          <input name='resource_attchment' className='form-control' type='file'
                            onChange={this.handleFile} />
                          
                      </div>



                       <div class="form-group row">
                          <div class="col-sm-10">
                            <button type="button" onClick={this.saveResource} class="btn btn-primary">Save</button>
                          </div>
                        </div>
                         
                      </div>

                     </div>

                     
                    </form>
                  }
                  
                  <div class="row col-lg-12">
                    
                      <div class="pt-3 table-responsive">
                    <table class="table table-bordered table-striped table-sm">
                      <thead class="thead-dark">
                        <tr>
                          <th >
                            <strong>S.No</strong>
                          </th>
                          <th >
                            <strong>Category</strong>
                          </th>
                     
                          <th>
                            <strong>Title</strong>
                          </th>

                          <th>
                            <strong>Downloads</strong>
                          </th>

                          <th >
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {resourceslist.map((item, i) => {     
                      
                       return <tr>
                          <td  >
                            {i+1}
                          </td>
                                                  
                           <td  >
                            {item.category}
                          </td>
                           <td  >
                            {item.title}
                          </td>
                           <td  >
                            {item.downloads}
                          </td>
                         
                          
                          
                          <td  class="actionbtns" dangerouslySetInnerHTML={{__html: item.action}} />                             

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>


                  </div>
                    
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default resourcesList;


// WEBPACK FOOTER //
// ./src/components/bewise/resourceList.jsx